function sendEventAddSchool({schoolId}) {
    const gtm = window.dataLayer

    if(!gtm) return

    gtm.push({
        event: 'add-school',
        schoolId,
    })
}

function sendEventRemoveSchool({schoolId}) {
    const gtm = window.dataLayer

    if(!gtm) return

    gtm.push({
        event: 'remove-school',
        schoolId,
    })
}

function sendEventSignup({email}) {
    const gtm = window.dataLayer

    if(!gtm) return

    gtm.push({
        event: 'signup',
        email,
    })
}

function sendEventLogin({email}) {
    const gtm = window.dataLayer

    if(!gtm) return

    gtm.push({
        event: 'login',
        email,
    })
}

function sendEventVerified({email}) {
    const gtm = window.dataLayer

    if(!gtm) return

    gtm.push({
        event: 'verified',
        email,
    })
}

export default {
    sendEventAddSchool,
    sendEventRemoveSchool,
    sendEventSignup,
    sendEventLogin,
}



// WEBPACK FOOTER //
// ./react/analytics/api.js